<template>
  <div
    id="stock-order-basket"
    class="d-block bg-white2 w-full"
    v-if="Object.keys(stockOrder).length != 0"
  >
    <vs-row
      id="orderActions"
      v-if="stockOrder.id && isPreview"
      vs-type="flex"
      vs-w="12"
    >
      <vs-row id="orderActionHeader" vs-type="flex" vs-w="12" class="p-4">
        <vs-col vs-type="block" vs-w="11">
          <span class="text-primary w-full d-block weight-600 text-medium-small">
          {{ stockOrder.branch.name }} #{{ stockOrder.id }}
        </span>
          <span
            class="weight-600 w-full text-smaller"
            :class="$getOrderStatusColor(stockOrder.status)"
          >
          {{ $getOrderStatus(stockOrder.status) }}
        </span>
        </vs-col>
        <vs-col v-if="screenWidth < 959" vs-type="flex" vs-w="1" vs-align="flex-start">
          <feather-icon icon="XIcon" @click.stop="onCloseSideBar" class="cursor-pointer"></feather-icon>
        </vs-col>
      </vs-row>
      <vs-row
        id="orderActionContent"
        vs-type="flex"
        vs-w="12"
        vs-justify="center"
        class="px-4"
      >
        <img :src="getOrderSvg" class="px-4 my-6"/>
        <div
          v-if="($isCenterBranch() || $isRegionalCenterBranch()) && !(stockOrder.branch && $currentUser.branch && stockOrder.branch.id === $currentUser.branch.id)"
          class="d-flex w-full justify-center align-center text-center"
        >
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 1"
          >
            <b class="text-primary">{{ stockOrder.branch.name }}</b> şubesi
            toplamda <b>{{ stockOrder.totalEntryCount }}</b> kalem stok siparişi
            talep ediyor.
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 0"
          >
            <b class="text-primary">{{ stockOrder.branch.name }}</b> şubesinin
            <b>{{ stockOrder.totalEntryCount }} kalemlik</b> siparişi
            hazırlanmaya devam ediyor.
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 5"
          >
            <b class="text-primary">{{ stockOrder.branch.name }}</b> şubesinin
            <b>{{ stockOrder.totalEntryCount }} kalemlik</b> siparişi eksik
            gönderildi. Şubenin teslimatı onaylaması bekleniyor.
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 3"
          >
            <b class="text-primary">{{ stockOrder.branch.name }}</b> şubesinin
            <b>{{ stockOrder.totalEntryCount }} kalemlik</b> siparişi eksik
            gönderildi. <b>Eksiklerin tamamlanması bekleniyor.</b>
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 4"
          >
            <b class="text-primary">{{ stockOrder.branch.name }}</b> şubesinin
            <b>{{ stockOrder.totalEntryCount }} kalemlik</b> sipariş tam olarak
            gönderildi. <b>Teslimatın onaylanması</b> tamamlanması bekleniyor.
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 2"
          >
            <b class="text-success">
              Tüm stoklar gönderildi ve teslim alındı. Sipariş Tamamlandı !
            </b>
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 6"
          >
            <b class="text-danger">
              Tüm Sipariş Şube Tarafından İptal Edildi !
            </b>
          </span>
        </div>
        <div
          v-else-if="(!$isCenterBranch() && !$isRegionalCenterBranch()) || (stockOrder.branch && $currentUser.branch && stockOrder.branch.id === $currentUser.branch.id)"
          class="d-flex w-full justify-center align-center text-center"
        >
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 1"
          >
            Siparişin henüz <b class="text-warning">beklemede</b>.
            <b>Merkez</b>, siparişi onayladığında haberdar olacak olacaksın.
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-else-if="stockOrder.status == -1"
          >
            Sipariş gönderildikten sonra
            <b>{{ orderedStocks.length }} kalem stok</b> siparişiniz
            <b>onay sürecine</b> girecek.
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-else-if="stockOrder.status == 0"
          >
            Siparişiniz henüz hazırlık aşamasında.<b class="text--primary"
          >Merkez</b
          >
            siparişini gönderdiğinde haberdar olacaksın.
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 5"
          >
            <b class="text-primary">Merkez,</b> siparişinin bir kısmını
            yollayabildi. Teslim alınan stokları kontrol edip, teslimatı
            onaylayınız. <b>Eksik kalan</b> stoklar merkez tarafından tekrar
            gönderilebilir.
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 3"
          >
            <b class="text-primary">Merkezin</b> eksik kalan stokları
            tamamlaması bekleniyor. Tekrar gönderildiğinde teslimat onayı
            istenecektir.
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 4"
          >
            <b class="text-primary">Merkez,</b> siparişin doğrultusun da talep
            ettiğin tüm stokları göndermiş durumda. Siparişi tamamlayabilmek
            için <b>teslimatın onaylanması bekleniyor.</b>
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 2"
          >
            <b class="text-success"
            >Tüm stoklar gönderildi ve teslim alındı. Sipariş Tamamlandı !</b
            >
          </span>
          <span
            class="text-smaller weight-500 text-center"
            v-if="stockOrder.status == 6"
          >
            <b class="text-danger">
              Tüm Sipariş Şube Tarafından İptal Edildi !
            </b>
          </span>
        </div>
        <vs-row
          v-if="(!$isCenterBranch() && !$isRegionalCenterBranch()) || (stockOrder.branch && $currentUser.branch && stockOrder.branch.id === $currentUser.branch.id)"
          vs-type="flex"
          vs-w="12"
          class="mt-4 pb-4"
        >
          <vs-row
            v-if="stockOrder.status == -1 || stockOrder.status == 1"
            vs-type="flex"
            vs-w="12"
          >
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <vs-col vs-type="flex" vs-w="5">
                <vs-button
                  @click="editOrder"
                  icon-pack="feather"
                  color="transparent"
                  icon="icon-arrow-left"
                  size="small"
                  class="p-3 weight-600 w-full bg-secondary2 mr-1"
                >
                  Siparişi Düzenle
                </vs-button>
              </vs-col>
              <vs-col vs-type="flex" vs-w="5">
                <vs-button
                  v-if="stockOrder.status == -1"
                  @click="onDeleteOrder"
                  color="danger"
                  icon-pack="feather"
                  icon="icon-x"
                  size="small"
                  class="p-3 weight-600 w-full ml-1"
                >
                  Siparişi Sil
                </vs-button>
                <vs-button
                  v-else
                  @click="onCancelOrder"
                  color="danger"
                  icon-pack="feather"
                  icon="icon-x"
                  size="small"
                  class="p-3 weight-600 w-full ml-1"
                >
                  Sipariş İptal
                </vs-button>
              </vs-col>
              <vs-col
                v-if="stockOrder.status == 1"
                vs-type="flex"
                vs-w="5"
                class="mt-2"
              >
                <vs-button
                  :disabled="!hasAnyValidRow"
                  @click="placeNewOrder"
                  color="success"
                  icon-pack="feather"
                  icon="icon-save"
                  size="small"
                  class="p-3 weight-600 w-full ml-1"
                >
                  Siparişi Güncelle
                </vs-button>
              </vs-col>
            </vs-row>
            <vs-row
              v-if="stockOrder.status == -1"
              vs-type="flex"
              vs-w="12"
              vs-justify="center"
              class="mt-2"
            >
              <vs-col vs-type="flex" vs-w="5" vs-justify="center">
                <vs-button
                  :disabled="!hasAnyValidRow"
                  @click="saveDraft"
                  icon-pack="feather"
                  color="primary"
                  icon="icon-save"
                  size="small"
                  class="p-3 weight-600 w-full mr-1"
                >
                  Taslağı Kaydet
                </vs-button>
              </vs-col>
              <vs-col vs-type="flex" vs-w="5" vs-justify="center">
                <vs-button
                  :disabled="!hasAnyValidRow"
                  @click="placeNewOrder"
                  color="success"
                  icon-pack="feather"
                  icon="icon-send"
                  size="small"
                  class="p-3 weight-600 w-full ml-1"
                >
                  Merkeze Gönder
                </vs-button>
              </vs-col>
            </vs-row>
          </vs-row>
          <vs-row
            v-if="stockOrder.status == 5 || stockOrder.status == 4"
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
          >
            <vs-button
              @click="onApproveReceive"
              icon-pack="feather"
              color="success"
              icon="icon-check-circle"
              size="small"
              class="p-3 weight-600 w-full"
            >
              Siparişim Ulaştı
            </vs-button>
          </vs-row>
        </vs-row>
        <vs-row v-else vs-type="flex" vs-w="12" class="mt-4 pb-4">
          <div
            v-if="stockOrder.status == -1 || stockOrder.status == 1"
            class="d-flex w-full justify-center"
          >
            <vs-button
              @click="onDeleteOrder"
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              size="small"
              class="p-3 weight-600 mr-1"
            >
              Siparişi Sil
            </vs-button>
            <vs-button v-if="isOrderApprovePermission"
              @click="preparingOrder"
              icon-pack="feather"
              color="success"
              icon="icon-check-circle"
              size="small"
              class="p-3 weight-600 ml-1"
            >
              Siparişi Onayla
            </vs-button>
          </div>
          <div
            v-else-if="stockOrder.status == 0 || stockOrder.status == 3"
            class="d-flex w-full justify-center"
          >
            <vs-button
              @click="sendOrder"
              :disabled="!hasAnyValidRow"
              icon-pack="feather"
              color="success"
              icon="icon-send"
              size="small"
              class="p-3 weight-600"
            >
              Siparişi Gönder
            </vs-button>
          </div>
        </vs-row>
      </vs-row>
    </vs-row>
    <vs-row id="orderBasket" v-else vs-type="flex" vs-w="12">
      <vs-row id="orderBasketHeader" class="p-4" vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
          <vs-col vs-type="flex" vs-w="10">
            <span class="text-primary weight-600 text-medium-small">
              Sipariş Sepetim #{{
                stockOrder.id == 0 ? "Yeni Sipariş" : stockOrder.id
              }}
            </span>
          </vs-col>
          <vs-col v-if="screenWidth < 959" vs-type="flex" class="sidebar-close w-auto">
            <feather-icon icon="XIcon" @click.stop="onCloseSideBar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </vs-row>
        <span id="orderBasketDescription" class="weight-500 text-smaller mt-4">
          Şubeniz için ihtiyacınız olan ürünleri sepete ekledikten ve kontrol
          ettikten sonra sipariş verebilirsiniz.
        </span>
      </vs-row>
      <vs-divider class="my-2"></vs-divider>
      <vs-row
        v-if="orderedStocks.length === 0"
        vs-type="flex"
        vs-w="12"
        class="py-4"
      >
        <vs-row vs-type="flex" vs-w="12" vs-justify="center">
          <img :src="require('@/assets/general/empty-cart.svg')" class="my-4"/>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="my-4">
          <span class="text-smaller weight-600">Sepetiniz Boş Görünüyor</span>
        </vs-row>
      </vs-row>
      <div v-else class="d-flex w-full vs-row">
        <vs-row
          id="orderBasketList"
          vs-type="flex"
          vs-w="12"
          style="max-height: 56vh; overflow-y: auto"
        >
          <vs-row vs-type="flex" vs-w="12" class="px-4">
            <vs-col vs-type="flex" vs-w="6" class="pr-1">
              <span class="text-primary weight-600 text-smaller">
                Ürün Adı
              </span>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" vs-justify="center" class="pl-1">
              <span class="text-primary weight-600 text-smaller"> Miktar </span>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" vs-justify="center" class="pl-1">
              <span class="text-primary weight-600 text-smaller"> Tutar </span>
            </vs-col>
          </vs-row>
          <vs-divider class="my-2"></vs-divider>
          <vs-row
            vs-type="flex"
            vs-w="12"
            v-for="(item, index) in orderedStocks"
            :key="item.stock.id"
            class="px-4"
            :class="{'bg-holoco' : item.stock.rawMaterial.stockCode.substring(0,3) == 'HLC',
              'border-bottom mb-2 pb-2': index != orderedStocks.length - 1,
            }"
          >
            <vs-col vs-type="flex" vs-w="6" class="pr-1">
              <vs-row vs-type="flex" vs-w="12">
                <vs-row vs-type="flex" vs-w="12">
                  <span
                    class="
                      text-secondary text-smaller
                      weight-600
                      d-block
                      opacity-50
                    "
                  >
                    Ürün {{ index + 1 }}
                  </span>
                </vs-row>
                <vs-row vs-type="flex" vs-w="12" class="mt-2">
                  <vs-col vs-type="flex" vs-w="1" vs-sm="2" vs-align="center">
                    <feather-icon
                      @click.stop="onRemoveFromBasket(item)"
                      icon="XIcon"
                      class="h-4 w-4 pointer text-primary"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="11" vs-sm="10">
                    <span>
                      <b class="text-smaller">{{
                          item.stock.rawMaterial.name
                        }}</b>
                      <span class="weight-500 text-xs ml-1">{{
                          item.unit.name
                        }}</span>
                    </span>
                  </vs-col>
                </vs-row>
              </vs-row>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" vs-align="center" class="pl-1">
              <vs-input
                type="number"
                :name="index + 1 + '.Sip Miktarı'"
                v-validate="{
                  required: true,
                  regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                  minValAccept0: item,
                }"
                v-model="item.quantity"
                @input="setQuantity(item)"
                class="
                  text-sm
                  border-only-bottom border-2 border-dark
                  input-center
                  weight-600
                  w-full
                  text-center
                "
                size="small"
              />
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" vs-align="center" class="pl-1">{{priceByRow(item)}}</vs-col>
          </vs-row>
        </vs-row>
        <vs-divider></vs-divider>
        <vs-row
          id="orderBasketActions"
          vs-type="flex"
          vs-w="12"
          vs-justify="center"
          class="px-4 pb-4"
        >
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" vs-w="8" class="pr-1" vs-justify="center">
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" class="pr-1" vs-justify="center">
            Toplam Tutar: {{totalBuyPrice}}
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" vs-w="6" class="pr-1" vs-justify="center">
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="pr-1" vs-justify="center">
            (Kdv dahil fiyattır)
          </vs-col>
        </vs-row>
          <vs-row vs-type="flex" vs-w="12" v-if="!$isCenterBranch()">
            <vs-row
              vs-type="flex"
              vs-w="12"
              vs-justify="center"
              v-if="!isPreview"
            >
              <vs-button
                @click="onClearBasket"
                icon-pack="feather"
                color="transparent"
                icon="icon-x"
                size="small"
                class="p-3 weight-600 bg-secondary2 mr-1 mb-1"
              >
                Temizle
              </vs-button>
              <vs-button
                @click="onPreviewOrder"
                icon-pack="feather"
                color="transparent"
                icon="icon-check-circle"
                size="small"
                class="p-3 weight-600 ml-1 bg-success2 text-light"
              >
                Sipariş Önizlemesi
              </vs-button>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" v-else>
              <vs-col vs-type="flex" vs-w="6" class="pr-1" vs-justify="center">
                <vs-button
                  @click="editOrder"
                  icon-pack="feather"
                  color="transparent"
                  icon="icon-arrow-left"
                  size="small"
                  class="p-2 w-full weight-600 bg-secondary3"
                >
                  Siparişi Düzenle
                </vs-button>
              </vs-col>
              <vs-col vs-type="flex" vs-w="6" class="pl-1" vs-justify="center">
                <vs-button
                  :disabled="!hasAnyValidRow"
                  @click="placeNewOrder"
                  icon-pack="feather"
                  color="transparent"
                  icon="icon-send"
                  size="small"
                  class="p-2 w-full weight-600 bg-success3 text-light"
                >
                  Merkeze Gönder
                </vs-button>
              </vs-col>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              v-if="stockOrder.status == -1 && isPreview"
              vs-justify="center"
              class="mt-2"
            >
              <vs-button
                :disabled="!hasAnyValidRow"
                @click="saveDraft"
                icon-pack="feather"
                color="transparent"
                icon="icon-save"
                size="small"
                class="p-3 weight-600 ml-1 bg-primary text-light"
              >
                Taslağı Kaydet
              </vs-button>
            </vs-row>
          </vs-row>
        </vs-row>
      </div>
    </vs-row>
  </div>
</template>

<script>
import {
  sendOrder,
  sendOrderForDealer,
  preparingStockOrder,
  preparingStockOrderForDealer,
  createNewStockOrder,
  placeNewOrder,
} from "@/api/StockOrder.js";
import {isGranted} from "@/utils/auth";
export default {
  name: "StockOrderBasket",
  props: {
    stockOrder: {
      type: Object,
      required: true,
    },
    isPreview: {
      type: Boolean,
      required: true,
    },
    checker: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      screenWidth: window.innerWidth
    };
  },
  computed: {
    isOrderApprovePermission(){
      return isGranted("stock_order_approve")
    },
    totalBuyPrice(){
      const totalPrice = this.orderedStocks.reduce((accumulator, currentValue) => {
  return accumulator + (currentValue.quantity * currentValue.stock.buyPrice);
}, 0);
return this.$toCurrency(totalPrice)
    },
    hasAnyValidRow() {
      return this.stockOrder.groupes
        .flatMap((group) => group.stocks)
        .some((x) => x.modifiedQuantity > 0);
    },
    orderedStocks() {
      return this.stockOrder.groupes
        .flatMap((group) => group.stocks)
        .filter((x) => x.quantity > 0);
    },
    getOrderSvg() {
      if (this.stockOrder.status == null) {
        return null;
      }
      var svgName = "";
      switch (this.stockOrder.status) {
        case -1:
          svgName = "stock-order-draft.svg";
          break;
        case 0:
          svgName = "send-order.svg";
          break;
        case 1:
          svgName = "waiting-approve.svg";
          break;
        case 2:
          svgName = "order-reached.svg";
          break;
        case 3:
          svgName = "order-reached.svg";
          break;
        case 4:
          svgName = "hub-approve.svg";
          break;
        case 5:
          svgName = "hub-approve.svg";
          break;
        case 6:
          svgName = "cancelled-order.svg";
          break;
      }
      return require("@/assets/general/" + svgName);
    },
  },
  methods: {
    priceByRow(row) {
        return  this.$toCurrency(row.quantity*row.stock.buyPrice);
      },
    sendOrder: async function () {
      if (this.checker) {
        if (this.$isRegionalCenterBranch()) {
          sendOrderForDealer(this.stockOrder)
          .then((res) => {
            if (res && res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Sipariş Gönderimi",
                text: "Sipariş Başarıyla Gönderildi !",
              });
              this.onReload();
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Sipariş Gönderim Hatası : " + res.status,
                text: "Sipariş Gönderilemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sipariş Gönderme Başarısız !",
            });
          });
        } else {
          sendOrder(this.stockOrder)
          .then((res) => {
            if (res && res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Sipariş Gönderimi",
                text: "Sipariş Başarıyla Gönderildi !",
              });
              this.onReload();
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Sipariş Gönderim Hatası : " + res.status,
                text: "Sipariş Gönderilemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sipariş Gönderme Başarısız !",
            });
          });
        }

      }
    },
    saveDraft: async function () {
      let checker = await this.$validator.validateAll();
      if (checker) {
        createNewStockOrder(this.stockOrder)
          .then((res) => {
            if (res && res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Stok Siparişi",
                text: "Sipariş Güncellendi !",
              });
              this.onReload();
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Yeni Sipariş Verilemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    placeNewOrder: async function () {
      let checker = await this.$validator.validateAll();
      if (checker) {
        placeNewOrder(this.stockOrder)
          .then((res) => {
            if (res && res.status == 200) {
              if (this.stockOrder.id && this.stockOrder.id != 0) {
                this.$vs.notify({
                  color: "success",
                  title: "Stok Siparişi",
                  text: "Sipariş Güncellendi !",
                });
              } else {
                this.$vs.notify({
                  color: "success",
                  title: "Stok Siparişi",
                  text: "Yeni Stok Siparişi Verildi !",
                });
              }
              this.onReload();
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Stok Siparişi Hata : " + res.status,
                text: "Sunucu Bağlantı Hatası !",
              });
            }
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: error.response.data.Errors[0].Message,
            });
          });
      }
    },
    onApproveReceive() {
      this.$emit("onApproveReceive");
    },
    onReload() {
      this.$emit("reload");
    },
    onPreviewOrder() {
      this.$emit("onPreviewOrder");
    },
    setQuantity(item) {
      if (item.quantity == "" || item.modifiedQuantity == null || !/\d/.test(item.quantity)) {
        item.quantity = 0;
      }
      item.modifiedQuantity = item.quantity;
    },
    onClearBasket() {
      this.$emit("onClearBasket");
    },
    onCloseSideBar() {
      this.$emit("onCloseSideBar")
    },
    onRemoveFromBasket(item) {
      this.$emit("onRemoveFromBasket", item);
    },
    preparingOrder: async function () {
      if (this.$isRegionalCenterBranch()) {
        preparingStockOrderForDealer(this.stockOrder.id)
        .then((res) => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: "success",
              title: "Onaylama İşlemi",
              text: "Sipariş Başarıyla Onaylandı",
            });
            this.onReload();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Silme İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      } else {
        preparingStockOrder(this.stockOrder.id)
        .then((res) => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: "success",
              title: "Onaylama İşlemi",
              text: "Sipariş Başarıyla Onaylandı",
            });
            this.onReload();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Silme İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      }

    },
    editOrder() {

      this.$emit("onEdit");
    },
    onDeleteOrder() {
      this.$emit("onDeleteOrder");
    },
    onCancelOrder() {
      this.$emit("onCancelOrder");
    },
  },
};
</script>

<style>
@media (max-width: 958px) {
  .sidebar-close {
    display: flex;
  }

  #stock-order-basket {
    margin-left: 0 !important
  }

}

</style>
